export const BENEFIT_CONFIG = 'benefit_config';

export const LAYOUT_TYPES = {
  COMPARISON: 'comparison',
  CONTRIBUTION: 'contribution',
  VOLUME: 'volume',
  BASIC: 'basic',
};
